import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import Ordi from '../../prefabs/chapitre1/ordi/Ordi.js';
import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import ReponsePopUp from '../../prefabs/global/ordi/ReponsePopUp.js';
import QuestionPanel_1 from '../../prefabs/chapitre1/questions/QuestionPanel_01.js';
import QuestionPanel_2 from '../../prefabs/chapitre1/questions/QuestionPanel_02.js';
import QuestionPanel_3 from '../../prefabs/chapitre1/questions/QuestionPanel_03.js';
import { tags } from '../../consts/Tags.js';
import DebriefPanel from '../../prefabs/chapitre1/DebriefPanel.js';
import SoundManager from '../../prefabs/SoundManager.js';


export default class Chapitre1 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre1"
        })
    }

    init(data){
        this.audioName = 'MemoriesOfParis';
        super.init(data);   
    }

    create(){
        super.create();

        // Ajout popup d'intro
        this.popupIntro = new PopUpBlue(this, this.width/2, this.height/2, 600, 340)
        this.popupIntro.setAlpha(0);


        let introText = "Le bureau de Leïla Cercis semble en ordre. Cherchons des indices sur sa disparition…";
        let popupIntroText = this.add.text(0, 0, introText, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
            wordWrap: { width: 540 }
        }).setOrigin(0.5, 0);
        this.popupIntro.addElementToBody(popupIntroText, 40);

        let buttonCloseIntro = new ButtonRounded(this, 0, 0,  { 
            text: "Fouiller la pièce",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        });
        this.popupIntro.addElementToBody(buttonCloseIntro, 40);
        buttonCloseIntro.y+= buttonCloseIntro.height/2
        buttonCloseIntro.setClickFunction( () => {
           this.popupIntro.animOut(() => {
                this.popupIntro.destroy(true);
                this.displayButtons();
            });
        })

        this.popupIntro.animIn()
    }


    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "carte_postale"){
            this.openIndiceCartePostale(id, data);
        }else if(data.type == "ordinateur"){
            this.openOrdinateur(id, data);
        }
    }

    openIndiceCartePostale(id, data){
        this.openIndice(id);
        let buttonNext = new ButtonDecor(this, 298, 306, -1)
        buttonNext.textElmt.setText("⮕")
        this.popup.add(buttonNext)
        this.popup.isFlipped = false
        buttonNext.setClickFunction( () => {
            if(!this.popup.isFlipped){
                buttonNext.textElmt.setText("⬅")
                this.popup.setBackground(data.imageKey2)
                this.tweens.add({
                    targets: this.popup.textElmt,
                    alpha: 0,
                    duration: 200,
                    onComplete: () => {
                        this.popup.setText(data.description2)
                        this.tweens.add({
                            targets: this.popup.textElmt,
                            alpha: 1,
                            duration: 200
                        })
                    }
                })
                this.popup.isFlipped = true
            }else{
                buttonNext.textElmt.setText("⮕")
                this.popup.setBackground(data.imageKey)
                this.tweens.add({
                    targets: this.popup.textElmt,
                    alpha: 0,
                    duration: 200,
                    onComplete: () => {
                        this.popup.setText(data.description)
                        this.tweens.add({
                            targets: this.popup.textElmt,
                            alpha: 1,
                            duration: 200
                        })
                    }
                })
                this.popup.isFlipped = false
            }
        })
    }

    openOrdinateur(id, data){
        if(this.ordi)
            return

        this.blurBackground();

        // Close ordi si on clique en dehors
        this.background.setInteractive()
        this.background.on('pointerup', () => {
            this.closePopup();
            this.background.disableInteractive();
            this.background.removeListener('pointerup');
        })

        // Ajout ordinateur
        this.ordi = new Ordi(this, this.width/2, this.height)
        this.ordi.setAlpha(0)
        this.ordi.y = this.height - this.ordi.height + 50

        this.ordi.animIn(() => {
            // Change la musique
            this.soundManager.playAudio('DangerAhead')

            // Affiche l'ordi bloqué si besoin
            if(this.ordi.isLocked()){
                this.popupMDP();
            }else{
                // Affiche le panneau de question si l'ordi est débloqué
                this.addQuestionPanel();
            }
        })
    }

    // Popup à l'ouverture de l'ordi quand il est bloqué
    popupMDP(){
        this.ordiPopup = new PopUpBlue(this, this.width/2, 910, 730, 340)

        let text = "Ah mince ! Il faut un mot de passe."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonNext = new ButtonRounded(this, 0, 0, {
            text: "Continuer de fouiller la pièce",
            color: Colors.Elmt.DarkBlue,
            hoverColor: Colors.Elmt.White,
            textColor: Colors.Text.White,
            textHoverColor: Colors.Text.DarkBlue,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addElementToBody(buttonNext, 35 + buttonNext.height/2)

        let buttonAide = new ButtonRounded(this, 0, 0, {
            text: "Besoin d'un indice ?",
            color: Colors.Elmt.DarkBlue,
            hoverColor: Colors.Elmt.White,
            textColor: Colors.Text.White,
            textHoverColor: Colors.Text.DarkBlue,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addElementToBody(buttonAide, 25 )

        this.ordiPopup.animIn()

        buttonNext.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.closePopup();
            })
        })

        buttonAide.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.popupAideOrdi();
            })
        })

    }

    // Popup d'aide devant l'ordi bloqué
    popupAideOrdi(){
        this.ordiPopup = new PopUpBlue(this, this.width/2, 950, 1230, 260)

        let text = "Le post-it sur la tasse semble indiquer que la solution se cache dans les posters de fleurs."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonAide = new ButtonRounded(this, 0, 0, {
            text: "Continuer de fouiller la pièce",
            color: Colors.Elmt.White,
            hoverColor: Colors.Elmt.DarkBlue,
            textColor: Colors.Text.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addElementToBody(buttonAide, 35 + buttonAide.height/2)

        this.ordiPopup.animIn()

        buttonAide.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.closePopup();
            })
        })
    }


    // Popup au débloquage de l'ordi, permet de débuter l'enquete ou de retourner à la pièce
    popupStart(){
        // MAJ progression
        this.chapitreProgression.ordi.locked = false;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);

        this.ordiPopup = new PopUpBlue(this, this.width/2, this.height/2, 550, 330)
        
        let textElmt = this.add.text(0, 0, "La docteure Leïla Cercis avait l’air de s’intéresser de près à des posts viraux sur les réseaux sociaux.", {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
            wordWrap: { width: 450 }, 
        }).setOrigin(0.5,0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonStart = new ButtonRounded(this, 0, 0, {
            text: "Démarrer l'enquête",
            color: Colors.Elmt.White,
            textColor: Colors.Text.DarkBlue,
            hoverColor: Colors.Elmt.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        buttonStart.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.ordi.unlockButtons()
                this.addQuestionPanel1();
            })
        })
        this.ordiPopup.addElementToBody(buttonStart, 35 + buttonStart.height/2)

        this.ordiPopup.animIn()
    }

    // Appelé par l'ordi quand le code est rentré correctement
    closePopupOrdi(endFunc){
        if(this.ordiPopup == null || this.ordiPopup == undefined) return;

        this.ordiPopup.animOut(() => {
            this.ordiPopup.destroy(true);
            this.ordiPopup = null;
            if(endFunc)
                endFunc();
        })
    }

    addQuestionPanel(){
        const num = this.chapitreProgression.ordi.question
        switch(num){
            case 1:
                this.addQuestionPanel1()
                break;
            case 2:
                this.addQuestionPanel2()
                break;
            case 3:
                this.addQuestionPanel3()
                break;
        }
    }

    // Panneau de question qui s'ouvre une fois l'enquete débutée
    addQuestionPanel1(){
        this.chapitreProgression.ordi.question = 1;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_1(this, 0, 0, {config: this.config.questions[0], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 100
        this.questionPanel.animIn();
    }

    addQuestionPanel2(){
        this.chapitreProgression.ordi.question = 2;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_2(this, 0, 0, {config: this.config.questions[1], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 100
        this.questionPanel.animIn();
    }

    addQuestionPanel3(){
        this.chapitreProgression.ordi.question = 3;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_3(this, 0, 0, {config: this.config.questions[2], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 100
        this.questionPanel.animIn();
    }

    addDebrief(){
        this.debrief = new DebriefPanel(this)
        this.debrief.depth = 100
        this.debrief.animIn();
    }

    closeDebrief(){
        this.debrief.destroy(true);

        this.closePopup()
        this.time.addEvent({
            delay: 500,
            callback: () => {
                let txt = 'Les indices parlent d’eux-mêmes : Leïla ne s’est pas contentée de lire ces posts viraux, son œil de botaniste y a décelé des failles. Elle a cherché des réponses en contactant un confrère de l’Institut Botanique de Rio qui prétendait détenir des preuves décisives.\n\nLa carte postale sur son bureau confirme son départ : elle espérait dissiper ses doutes, même si cette invitation tombait presque trop à point nommé.\n\n<class=\"Inter28BoldItalic\">En route pour Rio de Janeiro, la Cidade Maravilhosa</class>'
                this.popupFinChapitre(txt, 620, "DebutChapitre2");
            }
        })
    }

    closePanelQuestion(endFunc){
        if(this.questionPanel == null || this.questionPanel == undefined) return;

        // Ferme le panneau de question
        this.questionPanel.animOut(() => {
            this.questionPanel.destroy(true);
            this.questionPanel = null;

            if(endFunc)
                endFunc(this);
        })
    }



}